"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarWaterPumpingOffGridConstants = void 0;
class SolarWaterPumpingOffGridConstants {
    constructor() {
        this.emissionFactor = 1.3;
        this.emissionFactorUnit = "kWh/year";
    }
}
exports.SolarWaterPumpingOffGridConstants = SolarWaterPumpingOffGridConstants;
